module.exports = __webpack_public_path__ + "img/walkie-talkie.0b53614a.svg";